import { Modal } from "@sede-enterprise/shell-ds-react-framework";

const Loader = (props: { isLoading?: boolean; message?: string }) => {
  return (
    <Modal
      {...{
        closable: false,
        loading: true,
        bodyPadding: true,
        showFooter: false,
        loadingText:
          props.message !== undefined && props.message !== "" ? props.message : "Loading...",
      }}
      open={props.isLoading!}
      onClose={() => {}}
    ></Modal>
  );
};
export default Loader;
